import http from "./http.js";

export default {
  userGet(payload) {
    return http.get(`/userget/${payload.action}/${payload.id}`);
  },
  userPost(payload) {
    return http.post("/userpost", { payload });
  },
  chatGet(payload) {
    return http.get(`/chatget/${payload.action}/${payload.id}`);
  },
  chatPost(payload) {
    return http.post("/chatpost", { payload });
  },
  webinarPost(payload) {
    return http.post("/webinarpost", { payload });
  },
  webinarAdminPost(payload) {
    return http.post("/webinaradminpost", { payload });
  },
  zertifikatData(teilnahmeId, hash) {
    return http.get(`/zertifikatdata/${teilnahmeId}/${hash}`);
  },
  userUpload(files) {
    return http.post("/userupload", files, {
      headers: {
        "Content-Type": `multipart/form-data; boundary=${files._boundary}`,
      },
    });
  },


};
 